export default __webpack_public_path__ + "static/media/delivery-truck.1fef77b4.svg";